<p-toast position="top-right"></p-toast>

<app-composite-search [isGlpEligible]="isGlpEligible" [existingCartItemRequestType]="existingCartItemRequestType" (markDuplicates)="markDuplicates($event)" (AddCartItem)="AddCartItem($event)" (ShowMessage)="ShowMessage($event)">

</app-composite-search>

